import React, { createContext, useState } from 'react';
export const CompanyLogoContext = createContext();
import PropTypes from "prop-types"

export const CompanyLogoProvider = ({ children }) => {
    const [companyLogo, setCompanyLogo] = useState(null);
    return (
        <CompanyLogoContext.Provider value={{companyLogo, setCompanyLogo}}>
            {children}
        </CompanyLogoContext.Provider>
    );
};

CompanyLogoProvider.propTypes = {
    children: PropTypes.node.isRequired
};